<template>
  <form>
    <div class="row">
      <div class="col-lg-9">
        <div class="row">
          <div class="col-lg-12">
            <application-info></application-info>
          </div>
        </div>
        <div class="row">
          <div class="col-lg-12">
            <p class="font-weight-bold mt-3">{{$t('proposal_ev_fp.revision__budget_review')}}</p>

            <radio
              name="model.rev_general_information"
              value="accepted"
              v-model="EvaluationForm.model.rev_general_information"
              @input="handleClearanceBy('rev_general_information')">
              {{$t('proposal_ev_fp.revision__accepted')}}
            </radio>
            <radio
              name="model.rev_general_information"
              value="needs-more"
              v-model="EvaluationForm.model.rev_general_information"
              @input="handleClearanceBy('rev_general_information')">
              {{$t('proposal_ev_fp.revision__need_further_and_changes')}}
            </radio>
            <radio
              name="model.rev_general_information"
              value="not-accepted"
              v-model="EvaluationForm.model.rev_general_information"
              @input="handleClearanceBy('rev_general_information')">
              {{$t('proposal_ev_fp.revision__not_accepted')}}
            </radio>
          </div>
          <div class="col-lg-12 mt-3">
            <p class="font-weight-bold mb-3">{{$t('proposal_ev_fp.general__info_clearance_by')}}</p>
            <div v-if="EvaluationForm.model.rev_general_information_clearance_by && EvaluationForm.model.rev_general_information_clearance_by.user">
              <div>{{EvaluationForm.model.rev_general_information_clearance_by.user.name}}</div>
              <small>{{EvaluationForm.model.rev_general_information_clearance_by.updated_at}}</small>
            </div>
            <div v-else>-</div>
          </div>
          <div class="col-lg-8 mt-4">
            <h5 class="font-weight-bold">
              {{$t('proposal_ev_fp.general__comments_action_points')}}
            </h5>
            <comment-box :is-editable="EvaluationForm.isEditable" v-model="EvaluationForm.model.comments_rev_general_information" :comments="EvaluationForm.model.comments_rev_general_information" :pull-right="false"></comment-box>
          </div>
        </div>

        <div class="row">
          <div class="col-lg-12">
            <p class="font-weight-bold mt-3">{{$t('proposal_ev_fp.revision__esms')}}</p>

            <radio
              name="model.rev_project_proposal"
              value="accepted"
              v-model="EvaluationForm.model.rev_project_proposal"
              @input="handleClearanceBy('rev_project_proposal')">
              {{$t('proposal_ev_fp.revision__accepted')}}
            </radio>
            <radio
              name="model.rev_project_proposal"
              value="needs-more"
              v-model="EvaluationForm.model.rev_project_proposal"
              @input="handleClearanceBy('rev_project_proposal')">
              {{$t('proposal_ev_fp.revision__need_further_and_changes')}}
            </radio>
            <radio
              name="model.rev_project_proposal"
              value="not-accepted"
              v-model="EvaluationForm.model.rev_project_proposal"
              @input="handleClearanceBy('rev_project_proposal')">
              {{$t('proposal_ev_fp.revision__not_accepted')}}
            </radio>
          </div>
          <div class="col-lg-12 mt-3">
            <p class="font-weight-bold mb-3">{{$t('proposal_ev_fp.general__info_clearance_by')}}</p>
            <div v-if="EvaluationForm.model.rev_project_proposal_clearance_by && EvaluationForm.model.rev_project_proposal_clearance_by.user">
              <div>{{EvaluationForm.model.rev_project_proposal_clearance_by.user.name}}</div>
              <small>{{EvaluationForm.model.rev_project_proposal_clearance_by.updated_at}}</small>
            </div>
            <div v-else>-</div>
          </div>
          <div class="col-lg-8 mt-4">
            <h5 class="font-weight-bold">
              {{$t('proposal_ev_fp.general__comments_action_points')}}
            </h5>
            <comment-box :is-editable="EvaluationForm.isEditable" v-model="EvaluationForm.model.comments_rev_project_proposal" :comments="EvaluationForm.model.comments_rev_project_proposal" :pull-right="false"></comment-box>
          </div>
        </div>

        <div class="row">
          <div class="col-lg-12">
            <p class="font-weight-bold mt-3">{{$t('proposal_ev_fp.revision__technical_description')}}</p>

            <radio
              name="model.rev_budget"
              value="accepted"
              v-model="EvaluationForm.model.rev_budget"
              @input="handleClearanceBy('rev_budget')">
              {{$t('proposal_ev_fp.revision__accepted')}}
            </radio>
            <radio
              name="model.rev_budget"
              value="needs-more"
              v-model="EvaluationForm.model.rev_budget"
              @input="handleClearanceBy('rev_budget')">
              {{$t('proposal_ev_fp.revision__need_further_and_changes')}}
            </radio>
            <radio
              name="model.rev_budget"
              value="not-accepted"
              v-model="EvaluationForm.model.rev_budget"
              @input="handleClearanceBy('rev_budget')">
              {{$t('proposal_ev_fp.revision__not_accepted')}}
            </radio>
          </div>
          <div class="col-lg-12 mt-3">
            <p class="font-weight-bold mb-3">{{$t('proposal_ev_fp.general__info_clearance_by')}}</p>
            <div v-if="EvaluationForm.model.rev_budget_clearance_by && EvaluationForm.model.rev_budget_clearance_by.user">
              <div>{{EvaluationForm.model.rev_budget_clearance_by.user.name}}</div>
              <small>{{EvaluationForm.model.rev_budget_clearance_by.updated_at}}</small>
            </div>
            <div v-else>-</div>
          </div>
          <div class="col-lg-8 mt-4">
            <h5 class="font-weight-bold">
              {{$t('proposal_ev_fp.general__comments_action_points')}}
            </h5>
            <comment-box :is-editable="EvaluationForm.isEditable" v-model="EvaluationForm.model.comments_rev_budget" :comments="EvaluationForm.model.comments_rev_budget" :pull-right="false"></comment-box>
          </div>
        </div>
      </div>
    </div>
  </form>
</template>
<script>
  import {EvaluationForm} from "@/services";
  import InfoRight from './InfoRight';
  import ApplicationInfo from '../ApplicationInfo';
  import {CommentBox} from 'src/components';

  export default {
    components: {
      InfoRight,
      ApplicationInfo,
      CommentBox
    },
    data() {
      return {
        EvaluationForm
      }
    },
    beforeCreate() {
      if (!EvaluationForm.files.budget) {
        EvaluationForm.files.budget = {};
      }
    },
    beforeMount()
    {
      let vm = this;

      vm.loggedUser = vm.$store.getters['Auth/loggedUser'];
    },
    methods: {
      getError(fieldName) {
        return this.errors.first(fieldName);
      },
      validate() {
        return this.$validator.validateAll().then(res => {
          this.$emit('on-validated', res, this.model);
          return res;
        });
      },
      handleClearanceBy(model_name)
      {
        let vm = this;

        // if (!EvaluationForm.model[model_name + '_clearance_by'] || !EvaluationForm.model[model_name + '_clearance_by'].user)
        {
          let current_date = new Date();

          current_date.setHours(current_date.getHours() + 1);
          current_date = current_date.toJSON().slice(0, 19).replace('T', ' ');

          EvaluationForm.model[model_name + '_clearance_by'] = {
            user: {
              id: vm.loggedUser.id,
              name: vm.loggedUser.name
            },
            updated_at: current_date
          };

          vm.$forceUpdate();
        }
      },
    }
  }
</script>
